
import { debounce } from "lodash";

const TokenRoute = "oauth/token";

const inMemoryJWTManager = () => {
    let memory_token: string | null = null;
    let memory_expiresAt: Date | null = null;
    let refresh_token: string | null = null;
    const isExpired = () => (memory_token && memory_expiresAt && refresh_token && memory_expiresAt.getTime() < Date.now());

    const getTokenInternal = async (reset = false) => {
        if (!memory_token || isExpired() || reset) {
            if (!(process.env.AUTH_URL)) {
                throw new Error("Missing AUTH_URL environment variable!");
            }

            const url = process.env.AUTH_URL + TokenRoute;

            const content = new FormData();
            if (isExpired()) {
                content.append("refresh_token", refresh_token || "");
                content.append("grant_type", "refresh_token");
            }

            // TODO: Add profileId.

            memory_token = null;
            memory_expiresAt = null;
            refresh_token = null;

            const response = await fetch(url, {
                method: "POST",
                credentials: "include",
                body: content,
                headers: {
                    "pragma": "no-cache",
                    "cache-control": "no-cache",
                }
            });

            if (response.status === 200) {
                const result = await response.json();
                memory_token = result["access_token"]; // TODO: Get UserId and set on applicationInsights
                memory_expiresAt = new Date(Date.parse(result["expires_at"]));
                refresh_token = result["refresh_token"];
            }
            else if (response.status >= 500) {
                throw new Error(await response.text());
            }
        }

        return memory_token;
    };

    const getTokenDebounced = debounce(() => getTokenInternal(), 1000, { 'leading': true });
    const resetTokenDebounced = debounce(() => getTokenInternal(true), 1000, { 'leading': true });

    const getToken = (reset = false) => {
        if (reset)
            return resetTokenDebounced();
        else
            return getTokenDebounced();
    };

    return {
        getToken,
    }
};

export default inMemoryJWTManager();